import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { APIStatus, APIStatusOK } from '../../../api/apiError';
import { notifyError, notifySuccess } from '../../../api/axios';
import { reportApi } from '../../../api/report/reportApi';
import { HttpStatusCode } from 'axios';
import { t } from 'i18next';

export const sendSettlementReportToQB = createAsyncThunk(
    'sendSettlementReportToQB',
    async (settlementIds: number[], { rejectWithValue }) => {
        try {
            const response = await reportApi.sendSettlementToQuickBooks(
                settlementIds,
            );
            if (response && response === HttpStatusCode.Ok) {
                notifySuccess(t('Reports:settlementReportToQBSuccessMessage'));
            } else {
                notifyError(t('Reports:settlementReportToQBErrorMessage'));
            }
        } catch (error) {
            notifyError(t('Common:errorMessage'));
            return rejectWithValue(error);
        }
    },
);

interface ISendSettlementReportToQBState {
    loading: boolean;
    status: APIStatus;
    lastSuccessTimestamp: number | null;
}

const initialState: ISendSettlementReportToQBState = {
    loading: false,
    status: APIStatusOK,
    lastSuccessTimestamp: null,
};

export const sendSettlementReportToQBSlice = createSlice({
    name: 'sendSettlementReportToQB',
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(sendSettlementReportToQB.pending, state => {
            state.loading = true;
        });
        builder.addCase(sendSettlementReportToQB.fulfilled, state => {
            state.loading = false;
            state.lastSuccessTimestamp = Date.now();
        });
        builder.addCase(sendSettlementReportToQB.rejected, (state, action) => {
            state.loading = false;
            state.status = action.payload as APIStatus;
        });
    },
});

const SettlementReportToQBReducer = sendSettlementReportToQBSlice.reducer;
export default SettlementReportToQBReducer;
